import React from 'react';
import { Handle, Position } from 'reactflow';

// Keep in sync with REGIME_FAMILY_VALUES in strategies/data_service.py --
// there's no shared source of truth across the two languages.
const REGIME_FAMILY_VALUES = {
  growth_inflation: ['Goldilocks', 'Reflation', 'Stagflation', 'Disinflationary Slowdown'],
  volatility_risk: ['Calm Risk-On', 'Fragile Rally', 'Stress Event', 'Volatility Warning'],
  liquidity: [
    'Liquidity Expansion', 'Crisis Easing', 'Late-Cycle Tightening',
    'Restrictive Tightening', 'Restrictive Hold', 'Neutral Liquidity',
  ],
};

const FAMILY_LABELS = {
  growth_inflation: 'Growth / Inflation',
  volatility_risk: 'Volatility / Risk',
  liquidity: 'Liquidity',
};

export default function RegimeNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const family = data.family || 'volatility_risk';
  const options = REGIME_FAMILY_VALUES[family] || REGIME_FAMILY_VALUES.volatility_risk;

  const onFamilyChange = (newFamily) => {
    onChange('family', newFamily);
    // Selected regime must belong to the new family, or the backend sanitizer
    // will silently reset it to that family's first option.
    onChange('regime', REGIME_FAMILY_VALUES[newFamily][0]);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #4338ca',
      background: 'var(--card)',
      minWidth: 230,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#818cf8' }}>
        🌐 Macro Regime
      </div>

      <select
        value={family}
        onChange={(e) => onFamilyChange(e.target.value)}
        style={{ width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        {Object.keys(REGIME_FAMILY_VALUES).map((f) => (
          <option key={f} value={f}>{FAMILY_LABELS[f]}</option>
        ))}
      </select>

      <select
        value={data.regime || options[0]}
        onChange={(e) => onChange('regime', e.target.value)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        {options.map((r) => (
          <option key={r} value={r}>{r}</option>
        ))}
      </select>

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Outputs 1 when this rule-based macro regime matches on that historical date, otherwise 0. No lookahead -- point-in-time safe for backtesting.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#4338ca' }} />
    </div>
  );
}
